(function () {
  var VERSION = "1.0.0";
  var cache = new Map();

  if (window.VidaLabsCommitteeCarousel && window.VidaLabsCommitteeCarousel.version === VERSION) {
    window.VidaLabsCommitteeCarousel.scan();
    return;
  }

  function text(value, fallback) {
    if (value === null || value === undefined) return fallback || "";
    return String(value).trim() || fallback || "";
  }

  function html(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function field(item, names, fallback) {
    for (var i = 0; i < names.length; i += 1) {
      if (text(item && item[names[i]])) return item[names[i]];
    }
    return fallback || "";
  }

  function initials(name) {
    return text(name)
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) {
        return part.charAt(0).toUpperCase();
      })
      .join("") || "VL";
  }

  function safeUrl(value) {
    var url = text(value);
    return /^https?:/i.test(url) ? url : "";
  }

  function normalize(payload) {
    var list = Array.isArray(payload)
      ? payload
      : payload && (payload.profesionales || payload.doctores || payload.items || payload.data);

    if (!Array.isArray(list)) return [];

    return list.map(function (item) {
      return {
        name: text(field(item, ["nombre", "name", "full_name"])),
        specialty: text(field(item, ["especialidad", "specialty", "titulo"], "Profesional de la salud")),
        license: text(field(item, ["cedula", "cedula_profesional", "license"])),
        photo: safeUrl(field(item, ["foto", "photo", "image", "avatar"])),
        badge: text(field(item, ["badge", "rol", "role"], "Comite"))
      };
    }).filter(function (person) {
      return person.name;
    });
  }

  function load(source) {
    if (!source) return Promise.resolve([]);
    if (!cache.has(source)) {
      cache.set(source, fetch(source, { credentials: "omit" })
        .then(function (response) {
          if (!response.ok) throw new Error("Committee JSON unavailable");
          return response.json();
        })
        .then(normalize));
    }
    return cache.get(source);
  }

  function avatar(person) {
    var label = html(person.name);
    if (person.photo) {
      return '<span class="vl-committee-card__avatar"><img src="' + html(person.photo) + '" alt="' + label + '" loading="lazy"></span>';
    }
    return '<span class="vl-committee-card__avatar"><span>' + html(initials(person.name)) + '</span></span>';
  }

  function card(person) {
    return [
      '<article class="vl-committee-card">',
      '  <div class="vl-committee-card__head">',
      avatar(person),
      '    <div>',
      '      <h3 class="vl-committee-card__name">' + html(person.name) + '</h3>',
      '      <p class="vl-committee-card__specialty">' + html(person.specialty) + '</p>',
      person.license ? '      <p class="vl-committee-card__license">Ced. ' + html(person.license) + '</p>' : "",
      "    </div>",
      "  </div>",
      person.badge ? '  <span class="vl-committee-card__badge">' + html(person.badge) + '</span>' : "",
      "</article>"
    ].join("");
  }

  function updateControls(root) {
    var track = root.querySelector("[data-vl-committee-track]");
    var bar = root.querySelector("[data-vl-committee-progress]");
    var prev = root.querySelector("[data-vl-committee-prev]");
    var next = root.querySelector("[data-vl-committee-next]");

    if (!track) return;

    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var ratio = max ? track.scrollLeft / max : 1;
    if (bar) bar.style.width = Math.max(18, Math.round(ratio * 100)) + "%";
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function bindControls(root) {
    var track = root.querySelector("[data-vl-committee-track]");
    var prev = root.querySelector("[data-vl-committee-prev]");
    var next = root.querySelector("[data-vl-committee-next]");
    if (!track) return;

    function move(direction) {
      var firstCard = track.querySelector(".vl-committee-card");
      var distance = firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.82;
      track.scrollBy({ left: direction * distance, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { move(-1); });
    if (next) next.addEventListener("click", function () { move(1); });
    track.addEventListener("scroll", function () { updateControls(root); }, { passive: true });
    window.addEventListener("resize", function () { updateControls(root); });
    updateControls(root);
  }

  function hydrate(root) {
    if (!root || root.dataset.vlCommitteeReady === "true") return;
    root.dataset.vlCommitteeReady = "true";
    root.classList.add("is-loading");

    load(root.dataset.source)
      .then(function (people) {
        var track = root.querySelector("[data-vl-committee-track]");
        if (!track || !people.length) return;
        track.innerHTML = people.map(card).join("");
      })
      .catch(function () {
        root.classList.add("is-error");
      })
      .finally(function () {
        root.classList.remove("is-loading");
        bindControls(root);
      });
  }

  function scan() {
    document.querySelectorAll("[data-vl-committee-carousel]").forEach(hydrate);
  }

  window.VidaLabsCommitteeCarousel = {
    version: VERSION,
    scan: scan
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
})();
